<template>
	<div>
		<div style="display: flex;
			justify-content: space-between;
			align-items: center;
			margin: 0px 10px;
			padding-top: 10px;">
			<div style="width: 70%;">
				<img class="imgWidth" src="@/assets/image/home/GB_store.png" @click="routeRedirect('HomePointsgoods')" />
			</div>
			<div style="width: 30%;">
				<div>
					<img class="imgWidth" src="@/assets/image/home/sign_in.png" @click="routeRedirect('MemberPointSignin')"/>
				</div>
				<div @click="goShare">
					<img class="imgWidth" src="@/assets/image/home/share.png"/>
				</div>
			</div>
		</div>
		<div style="margin-top: 35px;">
			<div class="infoData" @click="routeRedirect('MemberProfileSet')">
				{{ $t('tool.profile') }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Toast } from 'mint-ui'

export default {
	name: 'IndexMenu',
	props: [],
	data () {
		return {
		}
	},
	computed: {
		...mapState({
			user: state => state.member.info
		})
	},
	created () {
	},
	methods: {
		...mapActions([
			'openInviteFriendsModal'
		]),
		routeRedirect(name) {
			if (!this.user) {
				Toast(this.$t('guest.need_more_please_login'))
				return;
			}

			this.$router.push({ 'name': name })
		},
		// 分享
		goShare() {
			if (!this.user) {
				Toast(this.$t('guest.need_more_please_login'))
				return;
			}

			this.openInviteFriendsModal()
		},
	}
}
</script>

<style lang='scss' scoped>
	.infoData {
		background: rgb(243, 182, 27);
		border-radius: 5px;
		padding: 12px;
		color: white;
		margin: 12px;
		text-align: center;
		font-size: 0.88rem;
		font-weight: bold;
		letter-spacing: 0.06rem;
	}
	.imgWidth {
		width: 100%;
	}
</style>
